import React from 'react';
import css from './BadgeIcon.module.scss';
import classes from 'classnames';
import { Badge, BadgeProps } from 'components/Badge';
import { Icon, IIconProps } from 'components/Icon';
import { RemoveProp } from 'common/types/TypeHelpers';
import { ButtonTypes } from 'common/types/ButtonTypes';

interface IBadgeIconProps {
	className?: string;
	icon: RemoveProp<IIconProps, 'size'>;
	badge?: BadgeProps;
	context?: ButtonTypes;
}

export const BadgeIcon: React.FC<IBadgeIconProps> = props => {
	const { className, children, icon, badge, context } = props;
	return (
		<span className={classes(className, css.badgeIcon)}>
			<Icon
				{...icon}
				size='large'
				context={context}
				className={classes(icon?.className, css.icon)}
			></Icon>
			<Badge {...badge} className={classes(badge?.className, css.badge)}>
				<span aria-hidden='true'>{children}</span>
			</Badge>
		</span>
	);
};
